<template lang="pug">
v-container(fluid class="tw-p-0 tw-m-0")
  div(class="tw-rounded-md tw-border tw-border-dashed tw-border-blueGray-lighten-4 px-3")
    v-row(no-gutters align="center" justify="space-between" class="tw-mx-4")
      v-col(cols="8")
        v-row(no-gutters align="center")
          v-col(cols="stretch" class=" tw--ml-2")
            v-input(hide-details)
              v-file-input(
                single-line
                dense
                solo
                full-width
                v-model="file"
                truncate-length="50"
                :clearable="false"
                show-size
                flat
                hide-details
                placeholder="Add file... "
                class=" tw-text-kPurple tw-border-none"
              )
      v-col(cols="3")
        v-row(no-gutters justify="end")
          v-col(cols="auto")
            v-btn(
              small
              :ripple="true"
              depressed
              @click="upload()"
              :disabled="loading || !file ? true : false"
              :loading="loading"
              color="indigo lighten-5"
              class="tw-ml-1 tw-text-indigo-lighten-1"
            )
              v-icon(small color="indigo lighten-1") mdi-tray-arrow-up
              span(:class="file ? 'tw-text-indigo-lighten-1' : ''" class="pl-1 ") {{ $t('Common.upload') }}
</template>
<script>
export default {
  data() {
    return {
      file: null,
      loading: false,
    };
  },
  computed: {
    opportunity() {
      return this.$route.params.id;
    },
  },
  methods: {
    upload() {
      this.loading = true;
      const file = new FormData();
      file.append('name', this.file.name);
      file.append('file', this.file);
      this.$store
        .dispatch('opportunities/files/add', [this.opportunity, file])
        .then((response) => {
          this.file = null;
          this.loading = false;
          this.$emit('fileAdded');
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    },
  },
};
</script>
